import { StandardFile } from '../shared/file/file';

/*  Created by:Upendram Reddy Tanuja
  Created on: 01-Aug-19 4:30 PM
  Purpose: Sign Up Class */


export class SignUpDetails {
  // first_name: string;
  // last_name: string;
  // email_id: string;
  password: string;
  confirm_password: string;
  grant_type: string;
  client_id: string;
  client_secret: string;
  primary_role: string;
  // isd: number;
  // mobile_number: number;
  // files: StandardFile;
  // experience: number;
  // skill_code: any = [];
  constructor(obj = {
    // first_name: '',
    // last_name: '',
    // email_id: '',
    password: '',
    confirm_password: '',
    grant_type: 'authorization',
    client_id: 't@ll!nt',
    client_secret: 't@ll!nt',
    primary_role: 'careers',
    // isd: 0,
    // mobile_number: null,
    // files: null,
    // experience: null,
    // skill_code: []

  }) {
    // this.first_name = obj.first_name || "";
    // this.last_name = obj.last_name || "";
    // this.email_id = obj.email_id || "";
    this.password = obj.password || "";
    this.confirm_password = obj.confirm_password || "";
    this.grant_type = obj.grant_type || 'authorization';
    this.client_id = obj.client_id || "t@ll!nt";
    this.client_secret = obj.client_secret || "t@ll!nt";
    this.primary_role = obj.primary_role || 'careers';
    // this.isd = obj.isd || 1001;
    // this.mobile_number = obj.mobile_number || null;
    // if (obj.files && typeof obj.files == "string" && obj.files != 'null') {
    //   obj.files = JSON.parse(obj.files);
    // }
    // else if (obj.files == '' || obj.files == 'null') {
    //   obj.files = null;
    // }
    // this.files = obj.files || null;
    // this.experience = obj.experience;
    // if (typeof obj.skill_code == "string") {

    //   obj.skill_code = JSON.parse(obj.skill_code);
    // }
    // this.skill_code = obj.skill_code || [];
  }
  setFormGroupData(obj) {
    // this.first_name = obj.first_name;
    // this.last_name = obj.last_name;
    // this.email_id = obj.email_id;
    this.password = obj.password;
    this.confirm_password = obj.confirm_password;
    // this.isd = obj.isd || 1001;
    // this.mobile_number = obj.mobile_number;
    // this.experience = obj.experience;
    // if (typeof obj.skill_code == "string") {

    //   obj.skill_code = JSON.parse(obj.skill_code);
    // }
    // this.skill_code = obj.skill_code || [];
  }
  setData(obj) {
    // this.first_name = obj.first_name;
    // this.last_name = obj.last_name;
    // this.email_id = obj.email_id;
    this.password = obj.password;
    this.confirm_password = obj.confirm_password;
    // this.isd = obj.isd || 1001;
    // this.mobile_number = obj.mobile_number;
    // if (obj.files && typeof obj.files == "string" && obj.files != 'null') {
    //   obj.files = JSON.parse(obj.files);
    // }
    // else if (obj.files == '' || obj.files == 'null') {
    //   obj.files = null;
    // }
    // this.files = obj.files || null;
    // this.experience = obj.experience;
    // if (typeof obj.skill_code == "string") {

    //   obj.skill_code = JSON.parse(obj.skill_code);
    // }
    // this.skill_code = obj.skill_code || [];

  }
  // setFile(obj) {
  //   if (obj.Name) {
  //     this.first_name = obj.Name;
  //   }
  //   if (obj.EMail) {
  //     this.email_id = obj.EMail;
  //   }

  //   if (obj.Totalexperience) {
  //     if (typeof obj.Totalexperience == "string") {
  //
  //       obj.Totalexperience = JSON.parse(obj.Totalexperience);
  //
  //     }
  //     this.experience = obj.Totalexperience;
  //   }

  //   if (obj.Mobile) {
  //     this.mobile_number = obj.Mobile;
  //   }
  //   this.isd = 1001;
  // }
  getFormGroupData() {
    return {
      // first_name: this.first_name || '',
      // last_name: this.last_name || '',
      // email_id: this.email_id || '',
      // experience: this.experience,
      // mobile_number: this.mobile_number,
      // isd: this.isd || 1001,
      password: this.password,
      confirm_password: this.confirm_password,
      // skill_code: this.skill_code || []
    }
  }
}
